import { createContext } from 'react'
import { TRouterValues } from './types'

export const RouteContext = createContext<TRouterValues>(undefined!)
